import React, { memo, useCallback, useMemo, useState} from "react";
import { Route } from "react-router";
import { Callout, H5, Intent } from "@blueprintjs/core";
import { IEFormsTemplateLight  } from "../../stores/formsStore/templates";
import css from "./style.module.scss";
import OfficeHeader from './OfficeHeader';
import PublicFormList from './PublicFormList';
import useTenantInstallationId from '../shared/useTenantInstallationId';
import { LocationSelection } from "../shared/LocationSelection";
import { IPrefillData } from "../../stores/formsStore";
import Header from "./Header";


export interface IProps {
  templates: IEFormsTemplateLight[];
  prefillData: IPrefillData;
  //tiid: string;
  //header?: React.ReactNode;
  headerContainerStyle?: React.CSSProperties;
  contentContainerStyle?: React.CSSProperties;
}

const PublicFormMenuPage: React.FC<IProps> = memo(({templates, prefillData,...pageProps}) => {
  const defaultLocId = typeof prefillData.Locations === 'undefined' ? "" : prefillData.Locations[0].LocationId;
  const [locationId, setLocationId] = useState(defaultLocId);
  const havePublicForms = templates.length > 0;

  const onLocationSelected = useCallback(async (locationId: string) => {
    setLocationId(locationId);
    console.log("onLocationSelected", locationId);
  }, []);

  const locationDropdown = havePublicForms
    ? <H5 style={{ flex: 1, marginLeft: '2em' }}>
        <LocationSelection
          prefillData={prefillData}
          selectedLocationId={locationId!}
          onLocationSelected={onLocationSelected}
          label="Select an office:"
          showAllSelection={false}
          showAcceptingFormsOnly={true}
        />
      </H5>
    : null

  const message = havePublicForms
    ? <H5 style={{ flex: 1, marginLeft: '2em' }}>Please complete the form(s) specified by the office.
    <br />Please close this browser tab once you've completed all the necessary forms.</H5>
    : <Callout intent={Intent.PRIMARY} style={{ width: 730 }} title="No forms are currently available. Please contact the office for further instructions." />;

  const tiid = useTenantInstallationId();

  const formsList = useMemo(() => !havePublicForms ? null : <Route render={() => <PublicFormList tiid={tiid!} templates={templates} locationId={locationId} />} />,
    [havePublicForms, locationId, templates, tiid])

  return (
    <div className={css.page}>
      {/* <Header containerStyle={pageProps.headerContainerStyle} >{pageProps.header}</Header> */}
      {prefillData.LogoUrl &&
        <Header containerStyle={pageProps.headerContainerStyle} >
          <OfficeHeader prefillData={prefillData} />
        </Header>}
      <div className={css.content} style={pageProps.contentContainerStyle}>
        {locationDropdown}
        {message}
        {formsList}
      </div>
    </div>);
})

export default PublicFormMenuPage;
